import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

export const Content = styled.div`
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;

  h2 {
    font-size: 28px;
    font-weight: 600;
    color: ${props => props.theme.palette.greyscale.grey900};
    margin-bottom: 16px;
  }

  > p {
    font-size: 16px;
    color: ${props => props.theme.palette.greyscale.grey500};
    margin-bottom: 40px;
  }

  @media(max-width: ${props => props.theme.breakpoints.tablet}) {
    padding: 20px;

    h2 {
      font-size: 24px;
    }

    > p {
      font-size: 14px;
    }
  }
`;

export const Form = styled.form`
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Label = styled.label`
  font-size: 14px;
  font-weight: 500;
  color: ${props => props.theme.palette.greyscale.grey900};
`;

export const Input = styled.input`
  width: 100%;
  padding: 12px;
  border: 1px solid ${props => props.theme.palette.greyscale.grey200};
  border-radius: 4px;
  font-size: 16px;
  transition: border-color 0.3s ease;

  &:focus {
    outline: none;
    border-color: ${props => props.theme.palette.primary.blue500};
  }

  &:disabled {
    background-color: ${props => props.theme.palette.greyscale.grey50};
    cursor: not-allowed;
  }
`;

export const Button = styled.button<{ variant?: 'primary' | 'secondary' }>`
  width: 100%;
  padding: 12px;
  background-color: ${props => props.variant === 'secondary'
    ? '#fff'
    : props.theme.palette.primary.blue500};
  color: ${props => props.variant === 'secondary'
    ? props.theme.palette.primary.blue500
    : '#fff'};
  border: ${props => props.variant === 'secondary'
    ? `2px solid ${props.theme.palette.primary.blue500}`
    : 'none'};
  border-radius: 4px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover:not(:disabled) {
    background-color: ${props => props.variant === 'secondary'
    ? props.theme.palette.primary.blue50
    : props.theme.palette.primary.blue700};
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const ErrorText = styled.p`
  color: #FF3838;
  background-color: #fff5f5;
  padding: 12px;
  border-radius: 4px;
  margin: 0;
  font-size: 14px;
`;